import React, { use, useCallback } from "react";
import { useI18n } from "../../hooks/i18n-hooks";
import { AuthManagerContext } from "../../contexts/AuthManager";
import VStack from "../../ui_atoms/VStack";
import ScreenCard from "../ScreenCard";

import Gap from "../../ui_atoms/Gap";
import MarkdownView from "../../components/MarkdownView";
import { useIntercom } from "../../hooks/intercom";

import Loading from "../../components/Loading";

import PhoneField from "../../components/PhoneField";

const PhoneNumberEditorScreen = () => {
    const { user } = use(AuthManagerContext);
    const { presentMessageComposer } = useIntercom();

    const i18n = useI18n();
    const onValidate = useCallback(async () => {
        await presentMessageComposer();
    }, [presentMessageComposer]);

    if (!user) {
        return (
            <VStack>
                <Loading />
            </VStack>
        );
    }

    return (
        <ScreenCard
            buttons={[
                {
                    title: i18n.t("profile.contact_support"),
                    onPress: onValidate,
                    mode: "secondary",
                },
            ]}
        >
            <VStack gap={1} alignment="stretch" h="2/3">
                <Gap gap={1} />
                <PhoneField
                    label={i18n.t("screens.phone_number_edit.phone_number")}
                    value={user.phoneNumber || undefined}
                    disabled
                />
                <Gap gap={0.5} />
                <MarkdownView
                    markdown={i18n.t("profile.contact_us_for_change")}
                    onLinkPress={() => {
                        void presentMessageComposer();
                        return false;
                    }}
                />
            </VStack>
        </ScreenCard>
    );
};

export default PhoneNumberEditorScreen;
